export default __webpack_public_path__ + "static/media/react-hero-logo.d389da8b.svg";